import { inject, Injectable } from '@angular/core';
import { catchError, forkJoin, of } from 'rxjs';
import { UsersService } from './users.service';
import { DOCUMENT } from '@angular/common';
import { APP_ACCESS_PATH } from '../constants/app-access.constants';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  private userService = inject(UsersService);
  private document = inject(DOCUMENT);

  init() {
    // This public page must work without a panel account or a reachable API.
    if (this.document.location.pathname === APP_ACCESS_PATH) {
      return of({ user: null });
    }
    return forkJoin({
      user: this.userService.getUserInfo().pipe(
        catchError((err) => {
          console.log(err)
          return of(null); // continua inicialização mesmo com erro
        })
      ),
    });
  }
}
